<template>
  <select-objective />
</template>
<script>
import SelectObjective from './components/SelectObjective.vue';
export default {
  components: {
    SelectObjective
  },
  data: function() {
    return {
      animation: {
        smTop: '-5px',
        smWidth: '110px',
        width: 240,
        height: 240,
        smHeight: 110,
        smWidth: 110
      },
      helpText: 'It helps us personalize your ads'
    };
  }
}
</script>